import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { STEP_CONTACT, STEP_TYPE, STEPS } from "../constants/steps";
import { ROOM_SIDE_CORRIDOR, ROOM_SIDE_ROOM } from "../constants/roomSides";
import { useConfiguratorStore } from './configurator';

export const useUiStore = defineStore("ui", () => {
    const configurationStore = useConfiguratorStore();

    // Scrolling
    const isScrollingUp = ref(true);

    // Details
    const details = ref(null);

    // Steps
    const visitedSteps = ref([STEP_TYPE]);
    const currentStepIndex = ref(0);
    const currentStep = computed(() => {
        return STEPS[currentStepIndex.value];
    });

    function setStepVisited(step){
        if(!visitedSteps.value.includes(step)){
            visitedSteps.value.push(step);
        }
    }

    function goToStep(step) {
        currentStepIndex.value = STEPS.indexOf(step);
        details.value = null;
        showDetails.value = false;
        showRoomConfig.value = false;
        showOverlayConfig.value = false;

        const scrollArea = document.querySelector(".ConfiguratorScrollArea");
        if (scrollArea) {
            scrollArea.scrollTop = 0;
        }

        isScrollingUp.value = currentStep.value !== STEP_CONTACT;
        const currentRoomSide = configurationStore.configuration.roomSide;
        const newRoomSide = currentStepIndex.value <= 1 ? ROOM_SIDE_CORRIDOR : ROOM_SIDE_ROOM;

        if(currentRoomSide !== newRoomSide){
            configurationStore.configuration.roomSide = newRoomSide;
        }

        setStepVisited(step);
    }

    function goToPreviousStep() {
        if (currentStepIndex.value > 0) {
            goToStep(STEPS[currentStepIndex.value - 1]);
        }
    }

    function goToNextStep() {
        if (currentStepIndex.value < STEPS.length - 1) {
            goToStep(STEPS[currentStepIndex.value + 1]);
        }
    }

    // show flags
    const showDetails = ref(false);
    const showOverlayConfig = ref(false);
    const showRoomConfig = ref(false);
    const showFloorConfig = ref(false);
    const showSaveConfig = ref(false);

    function toggleOverlayConfig(type) {
        showOverlayConfig.value = !showOverlayConfig.value;

        if (showOverlayConfig.value) {
            showRoomConfig.value = false;
            showFloorConfig.value = false;

            switch (type) {
                case "room":
                    showRoomConfig.value = true;
                    break;
                case "floor":
                    showFloorConfig.value = true;
                    break;
            }
        }
    }

    function loadInitialData(json) {
        if(json.currentStepIndex){
            currentStepIndex.value = json.currentStepIndex;
        }

        if(json.configurationData){
            visitedSteps.value = STEPS
        }
    }

    return {
        isScrollingUp,
        visitedSteps,
        currentStep,
        currentStepIndex,
        setStepVisited,
        goToStep,
        goToPreviousStep,
        goToNextStep,
        details,
        showDetails,
        showOverlayConfig,
        showRoomConfig,
        showFloorConfig,
        showSaveConfig,
        toggleOverlayConfig,
        loadInitialData,
    };
});
